var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51683 10.3219C5.20208 10.1093 4.9842 9.79878 4.86523 9.38825L5.59577 9.08719C5.66208 9.33981 5.77786 9.53559 5.94314 9.67456C6.10736 9.8135 6.30736 9.88194 6.54105 9.88194C6.77998 9.88194 6.98527 9.80931 7.15683 9.66403C7.32842 9.51878 7.41473 9.3335 7.41473 9.10928C7.41473 8.87981 7.3242 8.69244 7.14314 8.54719C6.96208 8.40194 6.73473 8.32928 6.46314 8.32928H6.04105V7.60612H6.41998C6.65367 7.60612 6.85052 7.54297 7.01052 7.41666C7.17052 7.29034 7.25052 7.11772 7.25052 6.89772C7.25052 6.70194 7.17892 6.54612 7.03577 6.42931C6.89261 6.31247 6.71155 6.25353 6.49155 6.25353C6.2768 6.25353 6.1063 6.31037 5.97995 6.42512C5.85364 6.53987 5.76205 6.68091 5.70417 6.84722L4.98102 6.54616C5.0768 6.27456 5.25261 6.03456 5.51048 5.82722C5.76839 5.61984 6.09786 5.51562 6.49786 5.51562C6.79364 5.51562 7.05995 5.57247 7.29577 5.68722C7.53155 5.80197 7.71683 5.96091 7.85052 6.163C7.9842 6.36616 8.05052 6.59353 8.05052 6.84616C8.05052 7.10406 7.98842 7.32194 7.8642 7.50091C7.73998 7.67984 7.58736 7.81669 7.4063 7.9125V7.95566C7.64523 8.05566 7.83998 8.20828 7.99367 8.41356C8.1463 8.61881 8.22314 8.86409 8.22314 9.15041C8.22314 9.43672 8.15052 9.6925 8.00523 9.91672C7.85998 10.1409 7.65892 10.3178 7.40417 10.4462C7.14839 10.5746 6.86102 10.6399 6.54208 10.6399C6.17261 10.6409 5.83158 10.5346 5.51683 10.3219Z",
    fill: "#0085F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 6.69717L9.20181 7.27717L8.80078 6.66873L10.2397 5.63086H10.7913V10.5266H10.0039V6.69717Z",
    fill: "#0085F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2105 12.2104H3.78942L2.58398 13.9866L3.78942 15.9999H12.2105L13.2064 13.8579L12.2105 12.2104Z",
    fill: "#00A94B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2105 0H1.26316C0.56525 0 0 0.56525 0 1.26316V12.2105L1.89475 13.5575L3.7895 12.2105V3.78947H12.2106L13.5069 1.89472L12.2105 0Z",
    fill: "#0085F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2104V14.7368C0 15.4347 0.56525 15.9999 1.26316 15.9999H3.78947V12.2104H0Z",
    fill: "#00802E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 3.7895L14.1057 2.57031L12.2109 3.7895V12.2106L13.915 13.1L16.0004 12.2106V3.7895Z",
    fill: "#FFBC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 3.78947V1.26316C16.0004 0.56525 15.4352 0 14.7373 0H12.2109V3.78947H16.0004Z",
    fill: "#0067D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2109 15.9999L16.0004 12.2104H12.2109V15.9999Z",
    fill: "#FF4131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.6fa66659ff848a8a751d1aca489dd6e3.svg";
export { ForwardRef as ReactComponent };